import { wasHeaderModalVisible } from '../actions/AppHeaderModalActions';

const CourseIndexState = (
  currentState = {
    isCourseIndexVisible: wasHeaderModalVisible('SHOW_INDEX'),
    filters: [
      {
        count: 0,
        key: 'all',
        label: 'All',
        active: true
      },
      {
        count: 0,
        key: 'text',
        label: 'Text',
        active: true
      },
      {
        count: 0,
        key: 'ia',
        label: 'Interactive Activities',
        active: true
      },
      {
        count: 0,
        key: 'animate',
        label: 'Animations',
        active: true
      },
      {
        count: 0,
        key: 'module-quiz',
        label: 'Module Quiz',
        active: true
      },
      {
        count: 0,
        key: 'quiz',
        label: 'Check Your Understandings',
        active: true
      },
      {
        count: 0,
        key: 'video',
        label: 'Videos',
        active: true
      },
      {
        count: 0,
        key: 'pka',
        label: 'Packet Tracers',
        active: true
      },
      {
        count: 0,
        key: 'lab',
        label: 'Labs',
        active: true
      },
      {
        count: 0,
        key: 'syntax',
        label: 'Syntax Checkers',
        active: true
      }
    ],
    countsSet: false,
    filteredCourse: undefined
  },
  action
) => {
  switch (action.type) {
    case 'SHOW_INDEX':
      return {
        ...currentState,
        isCourseIndexVisible: true
      };
    case 'HIDE_INDEX':
      return {
        ...currentState,
        isCourseIndexVisible: false
      };
    case 'UPDATE_FILTER_STATE':
      return {
        ...currentState,
        filters: action.filters,
        activeFilters: action.filters
          .filter(f => f.active && f.key !== 'all')
          .map(f => f.key),
        filteredCourse: action.filteredCourse,
        countsSet: true
      };
    case 'UPDATE_LP_STATE':
      return {
        ...currentState,
        filteredCourse: action.filteredCourse
      };
    case 'CLOSE_MODAL':
      return {
        ...currentState,
        isCourseIndexVisible: false
      };
    case 'RESET_COURSE_INDEX':
      return {
        isCourseIndexVisible: wasHeaderModalVisible('SHOW_INDEX'),
        filters: [
          {
            count: 0,
            key: 'all',
            label: 'All',
            active: true
          },
          {
            count: 0,
            key: 'text',
            label: 'Text',
            active: true
          },
          {
            count: 0,
            key: 'ia',
            label: 'Interactive Activities',
            active: true
          },
          {
            count: 0,
            key: 'animate',
            label: 'Animations',
            active: true
          },
          {
            count: 0,
            key: 'module-quiz',
            label: 'Module Quiz',
            active: true
          },
          {
            count: 0,
            key: 'quiz',
            label: 'Check Your Understandings',
            active: true
          },
          {
            count: 0,
            key: 'video',
            label: 'Videos',
            active: true
          },
          {
            count: 0,
            key: 'pka',
            label: 'Packet Tracers',
            active: true
          },
          {
            count: 0,
            key: 'lab',
            label: 'Labs',
            active: true
          },
          {
            count: 0,
            key: 'syntax',
            label: 'Syntax Checkers',
            active: true
          }
        ],
        countsSet: false,
        filteredCourse: undefined
      };
    default:
      return currentState;
  }
};
export default CourseIndexState;
